import React, { useEffect, useState, useRef } from "react";
import {
  Dialog, DialogActions, DialogContent, Button, Typography,
  Box, Card, CardContent, Grid, IconButton, Divider
} from "@mui/material";
import {
  DirectionsCar as CarIcon,
  LocalGasStation as LocalGasStationIcon,
  Speed as SpeedIcon,
  CalendarToday as CalendarTodayIcon,
  AccountCircle as AccountCircleIcon,
  Description as DescriptionIcon,
  Edit as EditIcon,
  Folder as FolderIcon,
  LocalShipping as LocalShippingIcon,
  Timer as TimerIcon,
  Build as BuildIcon,
} from "@mui/icons-material";
import api from "../../api";

// Importar los componentes de edición
import EditarMantenimiento from "../utilities/EditarMantenimiento";
import EditarInfraccion from "../utilities/EditarInfraccion";
import EditarViaje from "../utilities/EditarViaje";
import EditarCombustible from "../utilities/EditarCombustible";
import EditarDocumentacion from "./EditarDocumentacion";
import EditarConductor from "../utilities/EditarConductor";

import AgregarMantenimiento from "../utilities/AgregarMantenimiento";
import AgregarInfraccion from "../utilities/AgregarInfraccion";
import AgregarViaje from "../utilities/AgregarViaje";
import AgregarCombustible from "../utilities/AgregarCombustible";
import AgregarDocumentacion from "./AgregarDocumentacion";

const DetalleVehiculo = ({ selectedVehiculo, handleDetailClose }) => {
  const [vehiculo, setVehiculo] = useState(null);
  const [mantenimiento, setMantenimiento] = useState([]);
  const [combustibles, setCombustibles] = useState([]);
//  const [viajes, setViajes] = useState([]);
  const [seguros, setSeguros] = useState([]);
  const [infracciones, setInfracciones] = useState([]);
  const [documentos, setDocumentos] = useState([]);
  const [peajes, setPeajes] = useState([]);

  const [docsOpen, setDocsOpen] = useState(false);
  //  const [lightboxOpen, setLightboxOpen] = useState(false);
  //  const [lightboxImage, setLightboxImage] = useState(null);

  // Estado para edición
  const [editType, setEditType] = useState(null); // e.g. "mantenimiento", "viaje"
  const [itemToEdit, setItemToEdit] = useState(null);
  const [addType, setAddType] = useState(null);

  // useRef replacement for anchor links to sections
  const vehiculoRef = useRef(null);
  const mantenimientoRef = useRef(null);
  const combustibleRef = useRef(null);
//  const viajeRef = useRef(null);
  const infraccionRef = useRef(null);
  const documentacionRef = useRef(null);

  const openEditModal = (type, item) => {
    setEditType(type);
    setItemToEdit(item);
  };

  const closeEditModal = () => {
    setEditType(null);
    setItemToEdit(null);
    // Refresh data after editing
    if (selectedVehiculo) {
      const id = selectedVehiculo.id;
      api.get(`mantenimiento/?vehiculo=${id}`).then(res => setMantenimiento(res.data));
      api.get(`combustibles/?vehiculo=${id}`).then(res => setCombustibles(res.data));
//      api.get(`viajes/?vehiculo=${id}`).then(res => setViajes(res.data));
      api.get(`infracciones/?vehiculo=${id}`).then(res => setInfracciones(res.data));
      api.get(`documentos/?vehiculo=${id}`).then(res => setDocumentos(res.data));
    }
  };

  const openAddModal = (type) => {
    setAddType(type);
  };

  const closeAddModal = () => {
    setAddType(null);
    // Refresh the data
    if (selectedVehiculo) {
      const id = selectedVehiculo.id;
      api.get(`mantenimiento/?vehiculo=${id}`).then(res => setMantenimiento(res.data));
      api.get(`combustibles/?vehiculo=${id}`).then(res => setCombustibles(res.data));
//      api.get(`viajes/?vehiculo=${id}`).then(res => setViajes(res.data));
      api.get(`infracciones/?vehiculo=${id}`).then(res => setInfracciones(res.data));
      api.get(`documentos/?vehiculo=${id}`).then(res => setDocumentos(res.data));
    }
  };

  const fileInputRef = useRef(null);

  const handleImageEditClick = () => {
    fileInputRef.current.click();
  };

  const handleImageChange = async (event) => {
    const file = event.target.files[0];
    if (!file || !selectedVehiculo) return;

    const formData = new FormData();
    formData.append("imagen", file);

    try {
      const response = await api.patch(`vehiculos/${selectedVehiculo.id}/`, formData, {
        headers: { "Content-Type": "multipart/form-data" }
      });
      setVehiculo(response.data); // Update local state with new image
    } catch (error) {
      console.error("Error uploading image:", error);
    }
  };

  const groupedFields = {
    general: [
      'patente', 'marca', 'modelo',
    ],
    general_dos: ['anio', 'tipo_vehiculo', 'color', 'tipo_combustible', 'estado'],
    responsable: ['titular', 'direccion_sede', 'area_responsable', 'llave'],
    service: [
      'kilometraje', 'fecha_act_km',
      'fecha_ultimo_service', 'km_ultimo_service', 'km_proximo_service',
      'alineacion_balanceo_km'
    ],
    otros: ['tag', 'vencimiento_matafuego', 'carpeta_en_drive'],
    observaciones: ['observaciones_mecanicas', 'observaciones_carroceria'],
    chasis_motor: ['chasis', 'motor']
  };

  // Assign each group a subtle background color (adjust as needed)
  const groupColors = {
    general: '#f1f3f4',       // light blue
    general_dos: '#f1f3f4',       // light blue
    responsable: '#f1f3f4',   // light pink
    service: '#f1f3f4',       // light green
    otros: '#f1f3f4',         // light orange
    observaciones: '#f1f3f4', // light purple
    chasis_motor: '#f1f3f4'   // light gray
  };



  useEffect(() => {
    const style = document.createElement("style");
    style.type = "text/css";
    style.innerHTML = `
@media print {
  body * {
    visibility: hidden;
  }

  .printable, .printable * {
    visibility: visible;
  }

  .printable {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
  }

  .MuiDialogActions-root,
  .MuiButtonBase-root,
  .MuiIconButton-root {
    display: none !important;
  }

  .MuiCard-root, 
  .MuiBox-root, 
  .MuiPaper-root,
  .MuiGrid-container,
  .MuiTypography-root {
    page-break-inside: avoid;
    break-inside: avoid;
  }

  .MuiCardContent-root {
    page-break-inside: avoid;
  }

  a[href]:after {
    content: none !important;
  }
}
    `;
    document.head.appendChild(style);
    return () => {
      document.head.removeChild(style);
    };
  }, []);


  useEffect(() => {
    if (selectedVehiculo) {
      const id = selectedVehiculo.id;

      console.log("ID", id)

      api.get(`vehiculos/${id}/`).then(res => setVehiculo(res.data));
      api.get(`mantenimiento/?vehiculo=${id}`).then(res => setMantenimiento(res.data));
      api.get(`combustibles/?vehiculo=${id}`).then(res => setCombustibles(res.data));
//      api.get(`viajes/?vehiculo=${id}`).then(res => setViajes(res.data));
      api.get(`seguros/?vehiculo=${id}`).then(res => setSeguros(res.data));
      api.get(`infracciones/?vehiculo=${id}`).then(res => setInfracciones(res.data));
      api.get(`documentos/?vehiculo=${id}`).then(res => setDocumentos(res.data));
      api.get(`peajes/?vehiculo=${id}`).then(res => setPeajes(res.data));
    }
  }, [selectedVehiculo]);

  const iconMapping = {
    mantenimiento: <BuildIcon sx={{ mr: 1 }} />,
    combustible: <LocalGasStationIcon sx={{ mr: 1 }} />,
    viaje: <TimerIcon sx={{ mr: 1 }} />,
    infraccion: <LocalShippingIcon sx={{ mr: 1 }} />,
    documentacion: <FolderIcon sx={{ mr: 1 }} />,
  };

  const [visibleItemsCount, setVisibleItemsCount] = useState({});

  const handleShowMore = (type) => {
    setVisibleItemsCount(prev => ({
      ...prev,
      [type]: (prev[type] || 6) + 6
    }));
  };


  const renderListado = (items, label, type, ref) => {
    const excludeKeys = ["id", "vehiculo_nombre", "vehiculo", "conductor_id", "creado", "actualizado"];
    const keyLabels = {
      fecha_proximo_mantenimiento: "Próx. mantenimiento"
    };

    const visibleCount = visibleItemsCount[type] || 6;
    const shownItems = items.slice(0, visibleCount);

    return (
      <Box sx={{ marginTop: 3 }} ref={ref} backgroundColor="#fff" padding={2} borderRadius={2} boxShadow={2}>
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 2 }}>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            {iconMapping[type] || <BuildIcon sx={{ mr: 1 }} />}
            <Typography variant="h6" sx={{ color: "#152d51" }}>{label}</Typography>
          </Box>
          <Button
            size="small"
            onClick={() => openAddModal(type)}
            variant="contained"
            sx={{ minWidth: "32px", padding: "5px 8px", lineHeight: 1, backgroundColor: "#152d51", color: "#fff" }}
          >
            Agregar +
          </Button>
        </Box>

        <Divider sx={{ my: 2 }} />

        <Box
          sx={{
            display: "grid",
            gap: 2,
            gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
            gridAutoRows: "auto",
          }}
        >
          {shownItems.length > 0 ? (
            shownItems.map((item, idx) => (
              <Card
                key={idx}
                sx={{
                  position: 'relative',
                  borderLeft: "4px solid #152d51",
                  backgroundColor: item.pagada === false ? "#ffe6e6" : "#fff",
                  boxShadow: 2
                }}
              >
                <IconButton
                  size="small"
                  onClick={() => openEditModal(type, item)}
                  sx={{
                    boxShadow: 2,
                    position: 'absolute',
                    top: 8,
                    right: 8,
                    backgroundColor: '#f0f0f0',
                    '&:hover': { backgroundColor: '#e0e0e0' },
                  }}
                >
                  <EditIcon fontSize="small" />
                </IconButton>
                <CardContent sx={{ padding: 2 }}>
                  {console.log("Type:", type)}
                  {console.log("Item tipo:", item.tipo)}
                  {Object.entries(item)
                    .filter(([key]) => {
                      // Exclude generic keys
                      if (excludeKeys.includes(key)) return false;

                      // Special case for Documentacion: hide some fields unless it's a "Póliza de seguro"
                      if (type === "documentacion" && item.tipo !== "seguro") {
                        if (key === "suma_asegurada" || key === "tipo_cobertura") return false;
                      }

                      return true;
                    })
                    .map(([key, value], index) => {
                      if (key === "pagada") value = value ? "Sí" : "No";
                      if (key === "archivo" && value) {
                        return (
                          <Typography variant="body2" key={index} sx={{ mb: 0.5 }}>
                            <strong>Archivo:</strong>{" "}
                            <a href={value} target="_blank" rel="noopener noreferrer">Descargar</a>
                          </Typography>
                        );
                      } else {
                        return (
                          <Typography variant="body2" key={index} sx={{ mb: 0.5 }}>
                            <strong>{keyLabels[key] || key.replace(/_/g, " ").replace(/\b\w/g, c => c.toUpperCase())}:</strong> {String(value)}
                          </Typography>
                        );
                      }
                    })}
                </CardContent>
              </Card>
            ))
          ) : (
            <Typography variant="body2" color="textSecondary">
              No hay registros.
            </Typography>
          )}
        </Box>

        {visibleCount < items.length && (
          <Box display="flex" justifyContent="center" mt={2}>
            <Button
              onClick={() => setVisibleItemsCount(prev => ({
                ...prev,
                [type]: (prev[type] || 6) + 6
              }))}
              variant="outlined"
              size="small"
              color="#333333"
              sx={{ textTransform: "none" }}
            >
              Mostrar más
            </Button>
          </Box>
        )}
      </Box>
    );
  };


  return (
    <Dialog open={!!selectedVehiculo} onClose={handleDetailClose} fullWidth maxWidth="md">
      <DialogContent sx={{ backgroundColor: "#f4f6f9", padding: "24px" }}>
        <div className="printable">
          {vehiculo ? (
            <Card ref={vehiculoRef} sx={{ boxShadow: 3, borderRadius: 2, padding: 2 }}>
              <Typography variant="h6" sx={{ fontWeight: "bold", color: "#152d51", mb: 2, display: "flex", alignItems: "center" }}>
                <CarIcon sx={{ mr: 1 }} /> <strong>Detalles del Vehículo</strong>
              </Typography>
              <Divider sx={{ my: 2 }} />
              <Box sx={{ position: 'relative', overflow: 'hidden' }}>
                {/* Floated Image */}
                <Box sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  width: '50%',
                  float: 'right',
                }}
                >
                  <Box
                    sx={{
                      float: 'right',
                      width: 215,
                      position: 'relative',
                    }}
                  >
                    <Box
                      component="img"
                      src={vehiculo.imagen || "/static/car-placeholder.png"}
                      alt="Vehículo"
                      sx={{
                        width: '100%',
                        height: 'auto',
                        borderRadius: 2,
                        display: 'block',
                      }}
                    />
                    {/* Hidden file input for image upload */}
                    <input
                      type="file"
                      accept="image/*"
                      ref={fileInputRef}
                      style={{ display: "none" }}
                      onChange={handleImageChange}
                    />
                    <IconButton
                      size="small"
                      onClick={handleImageEditClick}
                      sx={{
                        position: 'absolute',
                        top: 8,
                        right: 8,
                        backgroundColor: '#f0f0f0',
                        boxShadow: 2,
                        '&:hover': { backgroundColor: '#e0e0e0' },
                      }}
                    >
                      <EditIcon fontSize="small" />
                    </IconButton>
                    {vehiculo.imagen && (
                      <IconButton
                        size="small"
                        onClick={async () => {
                          if (!selectedVehiculo) return;
                          if (!window.confirm("¿Eliminar la imagen del vehículo?")) return;
                          try {
                            await api.patch(`vehiculos/${selectedVehiculo.id}/`, { imagen: null });
                            setVehiculo({ ...vehiculo, imagen: null });
                          } catch (error) {
                            alert("Error al eliminar la imagen.");
                          }
                        }}
                        sx={{
                          position: 'absolute',
                          top: 8,
                          right: 44,
                          backgroundColor: '#ffeaea',
                          boxShadow: 2,
                          '&:hover': { backgroundColor: '#ffcccc' },
                          width: 32,
                        }}
                      >
                        <span style={{ color: '#d32f2f', fontWeight: 'bold', fontSize: 18 }}>×</span>
                      </IconButton>
                    )}
                  </Box>
                </Box>
                {/* Wrapping Info Items */}
                <Box>
                  {Object.entries(groupedFields).map(([groupKey, fields]) => {
                    const hasAnyValue = fields.some((key) => vehiculo[key] !== undefined);
                    if (!hasAnyValue) return null;

                    return (
                      <Box
                        key={groupKey}
                        sx={{
                          backgroundColor: groupColors[groupKey],
                          padding: 1.5,
                          marginBottom: 3,
                          borderRadius: '8px',
                          display: 'flex',
                          flexWrap: 'wrap',
                          gap: '12px',
                          justifyContent: 'flex-start',
                        }}
                      >
                        {fields.map((key) => {
                          const value = vehiculo[key];
                          if (value === undefined) return null;

                          const isWide = ['observaciones_mecanicas', 'observaciones_carroceria', 'direccion_sede', 'area_responsable', 'titular'].includes(key);

                          return (
                            <Box
                              key={key}
                              sx={{
                                flex: isWide ? '1 1 100%' : '1 1 45%',
                                background: '#fff',
                                borderRadius: '5px',
                                padding: 1.5,
                                minWidth: 0,
                              }}
                            >
                              <InfoItem
                                icon="&nbsp;&nbsp;-"
                                label={key.replace(/_/g, ' ').replace(/\b\w/g, (l) => l.toUpperCase())}
                                value={
                                  typeof value === 'object' && value !== null
                                    ? JSON.stringify(value)
                                    : value?.toString() || 'N/A'
                                }
                              />
                            </Box>
                          );
                        })}
                      </Box>
                    );
                  })}
                </Box>


                {/* Clear Float */}
                <Box sx={{ clear: 'both' }} />
              </Box>

            </Card>
          ) : (
            <Typography variant="body2" color="textSecondary">No se encontraron detalles del vehículo.</Typography>
          )}

          {/* Listados con edición */}
          {renderListado(mantenimiento, "Mantenimiento", "mantenimiento", mantenimientoRef)}
          {renderListado(combustibles, "Combustibles", "combustible", combustibleRef)}
          {/*  renderListado(viajes, "Viajes", "viaje", viajeRef) */}
          {renderListado(infracciones, "Infracciones", "infraccion", infraccionRef)}
          {renderListado(documentos, "Documentación", "documentacion", documentacionRef)}

        </div>

        {/* Editar Modals */}
        {editType === "mantenimiento" && (
          <Dialog open={true} onClose={closeEditModal} fullWidth maxWidth="sm">
            <DialogContent><EditarMantenimiento mantenimiento={itemToEdit} handleClose={closeEditModal} /></DialogContent>
            <DialogActions><Button onClick={closeEditModal}>Cerrar</Button></DialogActions>
          </Dialog>
        )}
        {editType === "infraccion" && (
          <Dialog open={true} onClose={closeEditModal} fullWidth maxWidth="sm">
            <DialogContent><EditarInfraccion infraccion={itemToEdit} handleClose={closeEditModal} /></DialogContent>
            <DialogActions><Button onClick={closeEditModal}>Cerrar</Button></DialogActions>
          </Dialog>
        )}
        {editType === "viaje" && (
          <Dialog open={true} onClose={closeEditModal} fullWidth maxWidth="sm">
            <DialogContent><EditarViaje viaje={itemToEdit} handleClose={closeEditModal} /></DialogContent>
            <DialogActions><Button onClick={closeEditModal}>Cerrar</Button></DialogActions>
          </Dialog>
        )}
        {editType === "combustible" && (
          <Dialog open={true} onClose={closeEditModal} fullWidth maxWidth="sm">
            <DialogContent><EditarCombustible combustible={itemToEdit} handleClose={closeEditModal} /></DialogContent>
            <DialogActions><Button onClick={closeEditModal}>Cerrar</Button></DialogActions>
          </Dialog>
        )}
        {editType === "documentacion" && (
          <Dialog open={true} onClose={closeEditModal} fullWidth maxWidth="sm">
            <DialogContent>
              <EditarDocumentacion documentacion={itemToEdit} handleClose={closeEditModal} />
            </DialogContent>
            <DialogActions>
              <Button onClick={closeEditModal}>Cerrar</Button>
            </DialogActions>
          </Dialog>
        )}

        {/* Add Modals */}
        {addType === "mantenimiento" && (
          <Dialog open={true} onClose={closeAddModal} fullWidth maxWidth="sm">
            <DialogContent>
              <AgregarMantenimiento vehiculo={selectedVehiculo} handleClose={closeAddModal} />
            </DialogContent>
            <DialogActions>
              <Button onClick={closeAddModal}>Cerrar</Button>
            </DialogActions>
          </Dialog>
        )}
        {addType === "infraccion" && (
          <Dialog open={true} onClose={closeAddModal} fullWidth maxWidth="sm">
            <DialogContent>
              <AgregarInfraccion vehiculo={selectedVehiculo} handleClose={closeAddModal} />
            </DialogContent>
            <DialogActions>
              <Button onClick={closeAddModal}>Cerrar</Button>
            </DialogActions>
          </Dialog>
        )}
        {addType === "viaje" && (
          <Dialog open={true} onClose={closeAddModal} fullWidth maxWidth="sm">
            <DialogContent>
              <AgregarViaje vehiculo={selectedVehiculo} handleClose={closeAddModal} />
            </DialogContent>
            <DialogActions>
              <Button onClick={closeAddModal}>Cerrar</Button>
            </DialogActions>
          </Dialog>
        )}
        {addType === "combustible" && (
          <Dialog open={true} onClose={closeAddModal} fullWidth maxWidth="sm">
            <DialogContent>
              <AgregarCombustible vehiculo={selectedVehiculo} handleClose={closeAddModal} />
            </DialogContent>
            <DialogActions>
              <Button onClick={closeAddModal}>Cerrar</Button>
            </DialogActions>
          </Dialog>
        )}
        {addType === "documentacion" && (
          <Dialog open={true} onClose={closeAddModal} fullWidth maxWidth="sm">
            <DialogContent>
              <AgregarDocumentacion vehiculo={selectedVehiculo} handleClose={closeAddModal} />
            </DialogContent>
            <DialogActions>
              <Button onClick={closeAddModal}>Cerrar</Button>
            </DialogActions>
          </Dialog>
        )}


        {/* Agrega más según necesites */}
      </DialogContent>

      <DialogActions sx={{ backgroundColor: "#f4f6f9" }}>
        <Button
          onClick={() => {
            if (vehiculoRef.current) {
              vehiculoRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
            } else {
              console.log("Ref for vehiculo is not set.");
            }
          }}
          variant="contained"
          sx={{ backgroundColor: "#333" }}
          fullWidth
        >
          <CarIcon sx={{ mr: 1 }} /> Vehi.
        </Button>
        <Button
          onClick={() => {
            if (mantenimientoRef.current) {
              mantenimientoRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
            } else {
              console.log("Ref for mantenimiento is not set.");
            }
          }}
          variant="contained"
          sx={{ backgroundColor: "#333" }}
          fullWidth
        >
          <BuildIcon sx={{ mr: 1 }} /> Mant.
        </Button>
        <Button
          onClick={() => combustibleRef.current.scrollIntoView({ behavior: "smooth", block: "start" })}
          variant="contained"
          sx={{ backgroundColor: "#333" }}
          fullWidth
        >
          <LocalGasStationIcon sx={{ mr: 1 }} /> Comb.
        </Button>
        {/*
        <Button
          onClick={() => viajeRef.current.scrollIntoView({ behavior: "smooth", block: "start" })}
          variant="contained"
          sx={{ backgroundColor: "#333" }}
          fullWidth
        >

          <TimerIcon sx={{ mr: 1 }} /> Viaj.
        </Button>
        */}
        <Button
          onClick={() => infraccionRef.current.scrollIntoView({ behavior: "smooth", block: "start" })}
          variant="contained"
          sx={{ backgroundColor: "#333" }}
          fullWidth
        >
          <LocalShippingIcon sx={{ mr: 1 }} /> Infr.
        </Button>
        <Button
          onClick={() => documentacionRef.current.scrollIntoView({ behavior: "smooth", block: "start" })}
          variant="contained"
          sx={{ backgroundColor: "#333" }}
          fullWidth
        >
          <FolderIcon sx={{ mr: 1 }} /> Docs.
        </Button>
        <Button
          onClick={() => window.print()}
          variant="contained"
          sx={{ backgroundColor: "#1976d2" }}
          fullWidth
        >
          Imprimir
        </Button>
        <Button onClick={handleDetailClose} variant="contained" sx={{ backgroundColor: "#152d51" }} fullWidth>
          Cerrar
        </Button>
      </DialogActions>

    </Dialog>
  );
};

const InfoItem = ({ icon, label, value }) => (
  <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
    {icon && <Box sx={{ mr: 1, color: "#152d51" }}>{icon}</Box>}
    <Typography variant="subtitle1"><strong>{label}:</strong> {value}</Typography>
  </Box>
);

export default DetalleVehiculo;
